// ScrollResetOnRouteChange — iter76.
// Scrolls window to top on every <Routes> route change. Renders nothing.
// Must be a child of <BrowserRouter>.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollResetOnRouteChange() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Use 'auto' (instant) so route transitions feel snappy. Smooth scroll
    // would jank on cold paint when content is still settling.
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    } catch {
      window.scrollTo(0, 0);
    }
  }, [pathname, search]);
  return null;
}
